import type { Country } from '../entities/Country';
import type { Environment, StripeBetaKey } from '../entities/enums';

const STAGING_STRIPE_PUBLIC_KEY = new Map<Country, string>([
  ['AU', 'pk_test_BgjSlFxxesmRQfLEusmL62I4'],
  ['HK', 'pk_test_0qBw6OFAH39xlMbJPbHqiNdq005lXweACG'],
  ['ID', 'pk_test_q0bdTzWRplR0gswbuiGGbkHl00Oef2ECXR'],
  ['MY', 'pk_test_U9OfHbyBecawc8hY96hLiYBb00qg9TOPzU'],
  ['NZ', 'pk_test_okMiZ2AVjfpw3PqMYlzNSFOT'],
  ['PH', 'pk_test_FKQAa5xe9Irw7JgZFrk8sXtI00YygTFAQz'],
  ['SG', 'pk_test_C6VfmehEPiJcUIoBPZEBmvGP'],
  [
    'TH',
    'pk_test_51LNQmsHfITs9qQ7GeK85RwEYkMWtcLBgEvJ6Aq9Hvy8IaDgKROBpYIP2yV9qiztghjWgCQaDGXsgtyO66ccidZWY00s4SU2Yct',
  ],
]);

const PROD_STRIPE_PUBLIC_KEY = new Map<Country, string>([
  ['AU', 'pk_live_4xJnYi8Fnl0cXoE0EM3mwJFt'],
  ['HK', 'pk_live_mBv28iGVFUX8nne2ASv9fGfh0047LElNQP'],
  ['ID', 'pk_live_9tT25WICbKXhU3GWJz6P4uGB00rlfC6Yrn'],
  ['MY', 'pk_live_N4wwAUhq1yi3HI79Ibd7MoIg00pS2XcKPk'],
  ['NZ', 'pk_live_lXounLQg840oL7Ud53RiqF2M'],
  ['PH', 'pk_live_nog4pQI8dXS410dYkAipxMTy009AmWvcGk'],
  ['SG', 'pk_live_9DjYQefzPqMvruWicrtLtHHW00tclgm7mK'],
  [
    'TH',
    'pk_live_51LsLU6CzoesiEw62MZ1XNg5LD7Y2mXyVI7eIQzlK3PVVyaDUo6rqzxAgJN2gCGNvDL88HEQ01gDMEsVB8vh93Iw500DDfXNeOD',
  ],
]);

const STAGING_STRIPE_BETA_PUBLIC_KEY = new Map<StripeBetaKey, string>([
  [
    'id_bank_transfer_beta_1',
    'pk_test_51HjrPMBe7ebLiWCfZ0Oo0nZhGsQ6QnPPULjCvFZQcgL7kXXYE0hY4LjNXzKONoPrqd1Ddp9HJ9quBaCGZfgVc1SZ00vnp4ISPb',
  ],
]);

const PROD_STRIPE_BETA_PUBLIC_KEY = new Map<StripeBetaKey, string>([
  ['id_bank_transfer_beta_1', 'pk_live_nwDwRwZtNfESis0ixaPhuL9U00OkpMNz4U'],
]);

const getStripePublicKey = (country: Country, env: Environment): string => {
  const useStagingPK = ['dev', 'staging'].includes(env);
  const stripePublicKeyMap = useStagingPK
    ? STAGING_STRIPE_PUBLIC_KEY
    : PROD_STRIPE_PUBLIC_KEY;

  if (!stripePublicKeyMap.has(country)) {
    return stripePublicKeyMap.get('AU')!;
  }

  return stripePublicKeyMap.get(country)!;
};

const getStripeBetaPublicKey = (
  key: StripeBetaKey,
  env: Environment,
): string => {
  const useStagingPK = ['dev', 'staging'].includes(env);
  const stripePublicKeyMap = useStagingPK
    ? STAGING_STRIPE_BETA_PUBLIC_KEY
    : PROD_STRIPE_BETA_PUBLIC_KEY;

  return stripePublicKeyMap.get(key)!;
};

export { getStripePublicKey, getStripeBetaPublicKey };
